import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useEmbedStore } from '../../lib/embedStore';

export default function ScrollToTop(): null {
  const location = useLocation();
  const isEmbed = useEmbedStore((s) => s.isEmbed);

  useEffect(() => {
    if (!isEmbed) return;
    try {
      window.scrollTo(0, 0);
    } catch (e) {
      // noop
    }
    // Notify parent window (host page) to scroll the iframe into view.
    try {
      const payload = {
        type: 'dp:scroll-to-top',
        path: `${location.pathname}${location.search || ''}${location.hash || ''}`,
        iframeId: (window.frameElement as HTMLIFrameElement)?.id || null,
      };
      // Use '*' here; host should verify origin in the listener.
      window.parent?.postMessage(payload, '*');
    } catch (e) {
      // noop
    }
  }, [location.pathname, location.search, location.hash, isEmbed]);

  return null;
}
